import _ from 'lodash';
import {
  getColorAndSizeForEan,
  getProductSizesByLengthForNumber,
} from './products';

import {
  getDeliveryPeriods
} from './productsDelivery'

import {
  mapDeliveryPeriods
} from '../utils/products'

const getLineItemForNewItemOrMaskLine = ({
  items,
  color,
  size,
  lineItem,
  gross,
  deliveryPeriodsMapped
}) => {
  const currentItems = { ...items } || {};
  const currentData = _.get(items, 'data') || {};
  const currentR = _.get(items, `data.${gross}`) || {};
  const data = {
    ...currentData,
    [gross]: {
      ...currentR,
      [color]: {
        [size]: lineItem.quantity,
      },
    },
  };

  let dpc = lineItem.delivery_period_code;
  if (dpc && !dpc.includes('_')) {
    dpc = lineItem.season + '_' + dpc;
  }

  let dp = deliveryPeriodsMapped[dpc];

  return {
    ...currentItems,
    [lineItem.mask_line_id]: {
      id: lineItem.mask_line_id,
      number: lineItem.item_no,
      season: lineItem.season,
      deliveryDate: dp,
      data,
    },
  };
};

const appendDataForExistingMasLine = ({
  items,
  lineItem,
  color,
  size,
  gross = 'r',
}) => {
  const nextItems = { ...items };

  nextItems[lineItem.mask_line_id] = {
    ...items[lineItem.mask_line_id],
    data: {
      ...nextItems[lineItem.mask_line_id].data,
      [gross]: {
        ...nextItems[lineItem.mask_line_id].data[gross],
        [color]: {
          ..._.get(nextItems[lineItem.mask_line_id], `data.${gross}.${color}`),
          [size]: lineItem.quantity,
        },
      },
    },
  };

  return nextItems;
};

export const lineItemForItem = ({
  color,
  size,
  lineItem,
  items,
  sizesByLength,
  deliveryPeriodsMapped
}) => {
  if (!lineItem) return items;
  if (!color || !size) return items;
  // return items;

  const gross = _.findKey(sizesByLength, (v) => v.includes(size)) || 'r';

  const isNewItemOrNewMaskline = !items || !items[lineItem.mask_line_id];
  if (isNewItemOrNewMaskline) {
    return getLineItemForNewItemOrMaskLine({
      items,
      color,
      size,
      lineItem,
      gross,
      deliveryPeriodsMapped
    });
  }

  return appendDataForExistingMasLine({
    items, lineItem, color, size, gross,
  });
};

export const lineItemsToOrderData = (
  context,
  lineItems,
  colorAndSizeForEan = getColorAndSizeForEan,
  productSizesByLengthForNumber = getProductSizesByLengthForNumber,
) => {
  if (!lineItems) return undefined;

  let i = 0;
  let items = null;

  const deliveryPeriods = getDeliveryPeriods(context);
  let deliveryPeriodKeys = Object.keys(deliveryPeriods);
  let dps = [];

  deliveryPeriodKeys.forEach((k) => {
    const x = deliveryPeriods[k];

    if (x.c) {
      dps.push({
        id: x.c,
        start: x.s,
        end: x.e
      });
    }
  });

  const deliveryPeriodsArr = mapDeliveryPeriods(dps);
  let deliveryPeriodsMapped = {};
  deliveryPeriodsArr.forEach((dp) => {
    deliveryPeriodsMapped[dp.value] = dp;
  });

  while (lineItems[i]) {
    const lineItem = lineItems[i];
    if (!lineItem.mask_line_id) {
      const maskLineId = `${lineItem.season}|${lineItem.item_no}|${lineItem.delivery_period_code}`;
      lineItem.mask_line_id = maskLineId;
    }

    const sizesByLength = productSizesByLengthForNumber(context)(
      lineItem.item_no,
    );

    const { color, size } = colorAndSizeForEan({
      number: lineItem.item_no,
      eanKey: Number(lineItem.ean),
      context,
    });

    items = lineItemForItem({
      size,
      lineItem,
      color,
      items,
      sizesByLength,
      deliveryPeriodsMapped
    });

    i += 1;
  }
  return items;
};
